import React, { FC, useState } from 'react';
import { IconButton } from '@material-ui/core';
import { MdEdit as EditIcon } from '@react-icons/all-files/md/MdEdit';
import EmployeeField from './EmployeeField';
import UpdateEmployeeModal from './UpdateEmployeeModal';

interface Props {
  employeeId: string;
  onChange: (value: string) => void;
}

const SupportEmployeeField: FC<Props> = ({ onChange, employeeId }) => {
  const [editModalOpen, setEditModalOpen] = useState(false);

  const handleChange = async (employeeId) => {
    await onChange(employeeId);
  };

  return (
    <>
      <EmployeeField
        InputProps={{
          readOnly: true,
          endAdornment: (
            <IconButton onClick={() => setEditModalOpen(true)}>
              <EditIcon />
            </IconButton>
          ),
        }}
        seeMore={false}
        employeeId={employeeId}
        label='Employé en charge'
      />

      <UpdateEmployeeModal
        onClose={() => setEditModalOpen(false)}
        open={editModalOpen}
        onValidate={handleChange}
        previousEmployeeId={employeeId}
      />
    </>
  );
};

export default React.memo(SupportEmployeeField);
